/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import Loader from "../common/loader";
import Select, { components } from "react-select";
import ReactPaginate from "react-paginate";
import { Tab, Nav } from "react-bootstrap";
import { MasterService } from "../../services";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import secureStorage from "../../config/encrypt";
import { TENANTS } from "../../config/constant";

const APP_VERSION_TENANTS = [TENANTS.OTO, TENANTS.FAV, TENANTS.TRIV, TENANTS.EMP];

const { ValueContainer, Placeholder } = components;

const AppVersionManagement = () => {
    const [filterOptions, setFilterOptions]   = useState({});
    const [versionList, setVersionList]       = useState([]);
    const [tenantList, setTenantList]         = useState([]);
    const [pageCount, setPageCount]           = useState(1);
    const [activeCount, setActiveCount]       = useState(0);
    const [inactiveCount, setInactiveCount]   = useState(0);
    const [currentStatus, setCurrentStatus]   = useState("1");
    const [offset, setOffset]                 = useState(0);
    const [loading, setLoading]               = useState(false);
    const [loginUserInfo]                     = useState(secureStorage.getItem('loginUserInfo'));
    const historyLead                         = useNavigate();

    useEffect(() => {
        getTenantList();
        getAppVersionList({ status: currentStatus });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // ── Data fetching ────────────────────────────────────────────────────────────

    const getTenantList = async () => {
        try {
            const response = await MasterService.post("/sfa/admin/get_tenant_list", {});
            if (response && response.data && response.data.status === 200) {
                const filtered = response.data.data.filter((t) =>
                    APP_VERSION_TENANTS.includes(t.tenant_value)
                );
                setTenantList(filtered);
            }
        } catch (_) {}
    };

    const getAppVersionList = (params) => {
        setLoading(true);
        MasterService.post("/sfa/admin/app_version_list", params)
            .then((response) => {
                if (response && response.data && response.data.status === 200) {
                    const { data, total, perPage, active, inactive } = response.data.data;
                    setVersionList(data);
                    setPageCount(Math.ceil(total / perPage));
                    setActiveCount(active);
                    setInactiveCount(inactive);
                } else {
                    toast.error(response.data.message);
                }
            })
            .catch((error) => toast.error(error))
            .finally(() => setLoading(false));
    };

    // ── Helpers ──────────────────────────────────────────────────────────────────

    const getTenantLabel = (tenantValue) => {
        const found = tenantList.find((t) => t.tenant_value === tenantValue);
        return found ? found.tenant_label : (tenantValue || '-');
    };

    // ── Event handlers ───────────────────────────────────────────────────────────

    const handleTabChange = (statusId) => {
        setCurrentStatus(statusId);
        setFilterOptions({});
        setOffset(0);
        getAppVersionList({ status: statusId });
    };

    const handleFilterChange = (field, value) => {
        setFilterOptions((prev) => ({ ...prev, [field]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setOffset(0);
        getAppVersionList({ ...filterOptions, status: currentStatus, page: 1 });
    };

    const resetFilter = () => {
        setFilterOptions({});
        setOffset(0);
        getAppVersionList({ status: currentStatus, page: 1 });
    };

    const handlePageClick = (e) => {
        const selectedPage = e.selected;
        setOffset(selectedPage);
        getAppVersionList({ ...filterOptions, page: selectedPage + 1, status: currentStatus });
    };

    const handleView = (id) => historyLead(`/view-app-version/${id}`);
    const handleEdit = (id) => historyLead(`/app-version-form/${id}`);

    const handleChangeStatus = async (id, newStatus) => {
        setLoading(true);
        try {
            const response = await MasterService.post("/sfa/admin/change_app_version_status", {
                id,
                status: newStatus,
                updated_by: loginUserInfo?.id || 0
            });
            if (response && response.data && response.data.status === 200) {
                toast.success(response.data.data);
                getAppVersionList({ ...filterOptions, status: currentStatus, page: offset + 1 });
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            toast.error(error);
        } finally {
            setLoading(false);
        }
    };

    // ── Render ───────────────────────────────────────────────────────────────────

    return (
        <React.Fragment>
            {loading ? <Loader /> : null}
            <div className="container-fluid">
                <div className="top-heading d-flex">
                    <h1>App Version Management</h1>
                    <div className="right-btn">
                        <button className="btn-line p-lg" onClick={() => historyLead("/app-version-form")}>
                            Add App Version
                        </button>
                    </div>
                </div>

                <div className="loan-filter-bg">
                    {/* ── Filters ── */}
                    <div className="top-filter-bg">
                        <div className="lead-list-filter">

                            {/* Tenant filter */}
                            <fieldset className="single-select">
                                <div className="material">
                                    <Select
                                        components={{ ValueContainer: CustomValueContainer }}
                                        id="tenant_id"
                                        name="tenant_id"
                                        onChange={(e) => handleFilterChange('tenant_id', e ? e.tenant_value : '')}
                                        options={tenantList}
                                        value={tenantList.filter((t) => filterOptions.tenant_id === t.tenant_value)}
                                        placeholder="Entity / Tenant"
                                        className="react-select"
                                        classNamePrefix="react-select"
                                        getOptionValue={({ tenant_value }) => tenant_value}
                                        getOptionLabel={({ tenant_label }) => tenant_label}
                                        isClearable
                                    />
                                </div>
                            </fieldset>

                            {/* Source filter */}
                            <fieldset className="single-select">
                                <div className="material">
                                    <Select
                                        components={{ ValueContainer: CustomValueContainer }}
                                        id="source"
                                        name="source"
                                        onChange={(e) => handleFilterChange('source', e ? e.id : '')}
                                        options={[{ id: 'Android App', label: 'Android App' }, { id: 'IOS App', label: 'IOS App' }]}
                                        value={[{ id: 'Android App', label: 'Android App' }, { id: 'IOS App', label: 'IOS App' }].filter((item) => filterOptions.source === item.id)}
                                        placeholder="Platform (Source)"
                                        className="react-select"
                                        classNamePrefix="react-select"
                                        getOptionValue={({ id }) => id}
                                        getOptionLabel={({ label }) => label}
                                        isClearable
                                    />
                                </div>
                            </fieldset>

                            <div className="btn-submit-reset m-sm-l">
                                <button onClick={handleSubmit} type="button" className="btn-primary">Search</button>
                                <button onClick={resetFilter} className="btn-reset">Reset</button>
                            </div>
                        </div>
                    </div>

                    {/* ── Tabs + Table ── */}
                    <div className="user-management-detail-tab-outer">
                        <Tab.Container id="app-version-tabs" defaultActiveKey="active">
                            <div className="user-managemnt-detail-tabs">
                                <Nav variant="pills" className="flex-column tab-line">
                                    <div className="tab-list">
                                        <Nav.Item onClick={() => handleTabChange("1")}>
                                            <Nav.Link eventKey="active">Active ({activeCount})</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item onClick={() => handleTabChange("0")}>
                                            <Nav.Link eventKey="inactive">Inactive ({inactiveCount})</Nav.Link>
                                        </Nav.Item>
                                    </div>
                                </Nav>
                            </div>

                            <div className="admin-table user-managemnt-detail-table data-table">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Entity / Tenant</th>
                                            <th>Platform</th>
                                            <th>Version</th>
                                            <th>Launch Type</th>
                                            <th>Android URL</th>
                                            <th>iOS URL</th>
                                            <th>Created Date</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {versionList && versionList.length ? (
                                            versionList.map((item, idx) => (
                                                <tr key={item.id}>
                                                    <td>{(offset * 20) + idx + 1}</td>
                                                    <td>
                                                        <span className="badge badge-secondary" style={{ textTransform: 'capitalize', fontWeight: 600 }}>
                                                            {getTenantLabel(item.tenant_id)}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span className={`badge badge-${item.source === 'Android App' ? 'success' : 'info'}`}>
                                                            {item.source || '-'}
                                                        </span>
                                                    </td>
                                                    <td><strong>{item.version || '-'}</strong></td>
                                                    <td>
                                                        <span style={{ color: item.launch_type === 'force' ? '#e74c3c' : '#27ae60', fontWeight: 600, textTransform: 'capitalize' }}>
                                                            {item.launch_type || '-'}
                                                        </span>
                                                    </td>
                                                    <td title={item.android_app_url || ''}>
                                                        {item.android_app_url
                                                            ? <a href={item.android_app_url} target="_blank" rel="noreferrer">Link</a>
                                                            : '-'}
                                                    </td>
                                                    <td title={item.ios_app_url || ''}>
                                                        {item.ios_app_url
                                                            ? <a href={item.ios_app_url} target="_blank" rel="noreferrer">Link</a>
                                                            : '-'}
                                                    </td>
                                                    <td>
                                                        {item.created_date
                                                            ? new Date(item.created_date).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })
                                                            : '-'}
                                                    </td>
                                                    <td>
                                                        <ul className="action-btn">
                                                            <li title="View">
                                                                <a className="btn btn-default" onClick={() => handleView(item.id)}>
                                                                    <i className="ic-remove_red_eyevisibility"></i>
                                                                </a>
                                                            </li>
                                                            <li title="Edit">
                                                                <a className="btn btn-default" onClick={() => handleEdit(item.id)}>
                                                                    <i className="ic-edit"></i>
                                                                </a>
                                                            </li>
                                                            <li title={currentStatus === '1' ? 'Deactivate' : 'Activate'}>
                                                                <a className="btn btn-default"
                                                                    onClick={() => handleChangeStatus(item.id, currentStatus === '1' ? '0' : '1')}>
                                                                    <i className={currentStatus === '1' ? 'ic-delete' : 'ic-check'}></i>
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="9" style={{ textAlign: "left" }}>No records found</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>

                                <div className="pagination-bx" id="appVersionList">
                                    <ReactPaginate
                                        previousLabel={"<"}
                                        nextLabel={">"}
                                        breakLabel={"..."}
                                        breakClassName={"break-me"}
                                        pageCount={pageCount}
                                        marginPagesDisplayed={2}
                                        forcePage={offset}
                                        pageRangeDisplayed={5}
                                        onPageChange={handlePageClick}
                                        containerClassName={"pagination"}
                                        subContainerClassName={"pages pagination"}
                                        activeClassName={"active"}
                                    />
                                </div>
                            </div>
                        </Tab.Container>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

const CustomValueContainer = ({ children, ...props }) => (
    <ValueContainer {...props}>
        <Placeholder {...props} isFocused={props.isFocused}>
            {props.selectProps.placeholder}
        </Placeholder>
        {React.Children.map(children, (child) => (child && child.type !== Placeholder ? child : null))}
    </ValueContainer>
);

export default AppVersionManagement;
